/**
 * What each realtime event refreshes (plan §10.3). Events are hints: the screens refetch,
 * so this table is the only place that knows which data an event touches.
 */
import type { RealtimeEvent } from '@shared/realtime/socket';

type Tag =
  | 'InboxSummary'
  | 'Notification'
  | 'ChatPartners'
  | 'ChatSaved'
  | 'Query'
  | 'Task'
  | 'Invoice'
  | 'BillingAnalytics'
  | { type: 'ChatThread'; id: string };

const thread = (e: RealtimeEvent): Tag[] =>
  typeof e.partnerId === 'string' ? [{ type: 'ChatThread', id: e.partnerId }] : [];

export function tagsFor(event: RealtimeEvent): Tag[] {
  switch (event.type) {
    case 'notification.created':
      return event.category === 'billing'
        ? ['InboxSummary', 'Notification', 'Invoice', 'BillingAnalytics']
        : ['InboxSummary', 'Notification'];
    case 'badge.changed':
      return ['InboxSummary', 'Notification'];
    case 'chat.message':
    case 'chat.deleted':
      return ['ChatPartners', 'ChatSaved', 'InboxSummary', ...thread(event)];
    case 'chat.edited':
      return ['ChatPartners', 'ChatSaved', ...thread(event)];
    case 'chat.delivered':
    case 'chat.read':
      return ['ChatPartners', ...thread(event)];
    case 'presence.changed':
      return typeof event.userId === 'string'
        ? ['ChatPartners', { type: 'ChatThread', id: event.userId }]
        : ['ChatPartners'];
    case 'query.updated':
      return ['Query', 'Task', 'InboxSummary', 'Notification'];
    case 'obligation.updated':
      return ['Task'];
    default:
      return [];
  }
}
